import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IoGlobals } from "../../ioglobals";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(public IO: IoGlobals, public router: Router) { }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.IO.USERS.info.check()) {
            this.router.navigate(['login']);
            return true;
        }
        if (!this.IO.isRun) {
            this.IO.ini();
        }
        this.IO.USERS.checkLogin();
        return true
    }
}
